import { FunctionComponent, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { concatClassNames } from '../../../utils';

interface IMainContentWrapperProps {
  className?: string;
  childClassName?: string;
}

/**
 * @deprecated This component is deprecated and should not be used in new code.
 * Please migrate to the new component.
 * @link src/global/components/PageLayout/PageLayout.tsx
 */
const MainContentWrapper: FunctionComponent<PropsWithChildren<IMainContentWrapperProps>> = ({ children, className, childClassName }) => (
  <main className={concatClassNames('flex-1 relative overflow-y-auto focus:outline-none', className || '')}>
    <div className={twMerge('py-6 px-6 h-auto', childClassName)}>{children}</div>
  </main>
);

export default MainContentWrapper;
